import { ModelRow } from "@mcleod/core";
import { AutogenLayoutRateExceptionDuplication } from "./autogen/AutogenLayoutRateExceptionDuplication";

export class RateExceptionDuplication extends AutogenLayoutRateExceptionDuplication {
   private _duplicates: ModelRow[] = [];


   public set duplicates(value: ModelRow[]) {
      this._duplicates = value;
   }

   public get duplicates(): ModelRow[] {
      return this._duplicates;
   }


}
